import { PasswordRequirements } from "../@types/PasswordRequirements";
import { isPasswordRequirements } from "../@types/PasswordRequirements";

export default async function fetchPasswordRequirements(
  token: string,
): Promise<PasswordRequirements> {
  try {
    const response = await fetch(
      `${window.REACT_APP_API_URL}/policy/password-requirements`,
      {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: unknown = await response.json();

    if (!isPasswordRequirements(data)) {
      throw new Error("Invalid password requirements format");
    }

    return data;
  } catch (error) {
    console.error("Failed to fetch password requirements:", error);
    throw error;
  }
}
